export default __webpack_public_path__ + "img/dmYWVYjY.05aef343.svg";